import { render, staticRenderFns } from "./MediaPages.vue?vue&type=template&id=cb54def0&"
import script from "./MediaPages.vue?vue&type=script&lang=js&"
export * from "./MediaPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb54def0')) {
      api.createRecord('cb54def0', component.options)
    } else {
      api.reload('cb54def0', component.options)
    }
    module.hot.accept("./MediaPages.vue?vue&type=template&id=cb54def0&", function () {
      api.rerender('cb54def0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/MediaPages.vue"
export default component.exports